import GLOBAL from './global';

function postXHR(options: any) {
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.open('POST', options.url || GLOBAL.__host__ + '/api/prajna', true);
    let headers: any = {
        "Content-Type": "application/x-www-form-urlencoded",
    };
    if (options.headers) {
        headers = options.headers;
    }
    Object.keys(headers).forEach((name) => {
        xhr.setRequestHeader(name, headers[name]);
    });
    xhr.onreadystatechange = (e) => {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                if (options.success) {
                    options.success();
                }
            } else { // report fail
                if (options.failure) {
                    options.failure();
                }
            }
        }
    };
    xhr.onerror = (e) => {
        if (options.error) {
            options.error(e);
        }
    };
    if (options.form) {
        xhr.send(options.data);
    } else {
        xhr.send('data=' + options.data);
    }
}

export default postXHR;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/util/xhr.ts